module.exports = __webpack_public_path__ + "img/food-17.9cf9cf78.jpg";